import React from 'react';

import classNames from 'classnames/bind';
import style from './ArticleSpreader.scss';
const ctx = classNames.bind(style);

import Spreader from '../Spreader';

const ArticleSpreader = props => (
  <Spreader>
    <div className={ctx('inner')}>{props.children}</div>
  </Spreader>
);

export default ArticleSpreader;
